import React, { useState } from "react";
import { Upload, Icon, message } from "antd";
import {
    UploadFile,
    UploadChangeParam,
    RcFile
} from "antd/lib/upload/interface";
import {
    checkCourseWareStr,
    getQiniuUploadToken
} from "../../../../service/service";

interface UploadProps {
    type: uploadType;
    onUpload?: (info: UploadChangeParam<UploadFile<any>>) => void;
}

const uploadUrl = "https://up-z1.qiniup.com";
const uploadName = "file";

export enum uploadType {
    File,
    Image
}

const UploadComponent: React.FC<UploadProps> = ({ type, onUpload }) => {
    const [token, setToken] = useState("");

    const beforeUpload = async (file: RcFile) => {
        if (checkCourseWareStr(file).next) {
            await getQiniuUploadToken()
                .then(res => {
                    setToken(res.message);
                    return Promise.resolve(file);
                })
                .catch(() => Promise.reject());
        } else {
            message.error(checkCourseWareStr(file).msg);
            return Promise.reject(file);
        }
    };

    return (
        <Upload
            accept={type === uploadType.File ? "" : "image/*"}
            action={uploadUrl}
            data={{ token }}
            name={uploadName}
            showUploadList={false}
            beforeUpload={beforeUpload}
            onChange={onUpload}>
            <button
                type="button"
                className="control-item button upload-button"
                data-title={type === uploadType.File ? "上传附件" : "上传图片"}>
                <Icon
                    type={type === uploadType.File ? "paper-clip" : "picture"}
                />
            </button>
        </Upload>
    );
};

export default UploadComponent;
